module.exports = __webpack_public_path__ + "img/ill-home-services-tech-support.a0dc0b82.svg";